/**
 * This function was designed to handle uploading evidence from the assessments page
 * @param form {FormData}
 * @param onProgress {Function} callback on progress update
 * @param onSuccess
 * @param onError
 */
export default function uploadFileViaAjax(form, {onProgress, onSuccess, onError}) {
    const options = {

        // nothing weird here - basic jQuery request
        url: "/api/upload",
        type: "POST",
        data: form,

        // tell jQuery not to worry about processing data or content-type
        // we "need" these
        cache: false,
        contentType: false,
        processData: false,

        // bind an event listener to the XHR for upload progress
        xhr: function() {
            const xhr = $.ajaxSettings.xhr();

            // if we're not uploading or tracking progress then just stop here
            if(!xhr.upload || !onProgress) {
                return xhr;
            }

            xhr.upload.addEventListener('progress', evt => onProgress(evt, form));

            return xhr;
        }

    };

    // bind success and failure events
    if(onSuccess) {
        options.success = (data, status, jqxhr) => onSuccess(form, data, status, jqxhr);
    }
    if(onError) {
        options.error = (jqxhr, status, errorMessage) => onError(form, jqxhr, status, errorMessage);
    }

    $.ajax(options)
}